// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"261":"8036a837","481":"651fe1e7","590":"ccab24f1","840":"7596d6df","844":"cb1ee7f5"}[chunkId] + ".chunk.css";
};